import { Layout, Typography, Row, Col, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import HeroSection from "../components/HeroSection";
import RequestAccessModal from "../components/RequestAccessModal";
import ControlCard from "../components/ControlCard";
import SearchSection from "../components/SearchSection";
import { useState } from "react";
import LogoHeader from "../components/LogoHeader";
import { CustomFooter } from "../components/Footer";
import { useSimpleSearch } from "../hooks/useSearch.ts";

// Import JSON data
import controlsData from "../data/controls.json";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export default function ControlsPage() {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const controls = controlsData;
  const allControls = [...controls.fedramp20x, ...controls.fedrampRev5];

  // Use the search hook
  const { searchTerm, searchResults, onSearch } = useSimpleSearch(allControls, [
    "id",
    "description",
  ]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const controlsData_typed = controlsData;
  const fedramp20xControls = controlsData_typed.fedramp20x.slice(0, 3);
  const fedrampRev5Controls = controlsData_typed.fedrampRev5.slice(0, 3);

  const totalFedramp20xControls = controlsData_typed.fedramp20x.length;
  const totalFedrampRev5Controls = controlsData_typed.fedrampRev5.length;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <LogoHeader />

      <Content style={{ padding: "48px 0", backgroundColor: "#fff" }}>
        <div
          style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}
        >
          <Breadcrumb
            style={{ marginBottom: "12px" }}
            items={[
              {
                title: <Link to="/">Trust Center</Link>,
              },
              {
                title: "Controls",
              },
            ]}
          />

          <HeroSection
            title="Controls"
            onRequestAccess={showModal}
            onSearch={onSearch}
          />

          <SearchSection
            searchTerm={searchTerm}
            totalResults={searchResults.length}
          >
            {searchResults.map((control, index) => (
              <Col xs={24} md={8} key={index}>
                <ControlCard control={control} />
              </Col>
            ))}
          </SearchSection>

          {!searchTerm && (
            <>
              <section style={{ marginBottom: "24px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <Title level={2}>FedRAMP 20x Low</Title>
                  <Link
                    to="/fedramp-20x-low"
                    style={{
                      fontWeight: 400,
                      color: "#2270FF",
                      textDecoration: "none",
                    }}
                  >
                    See All ({totalFedramp20xControls})
                  </Link>
                </div>
                <Paragraph
                  style={{
                    color: "#666",
                    marginBottom: "24px",
                    fontSize: "16px",
                  }}
                >
                  Controls are the specific safeguards or security requirements
                  put in place to reduce risk and protect systems, data, and
                  operations.
                </Paragraph>

                <Row gutter={[24, 24]}>
                  {fedramp20xControls.map((control, index) => (
                    <Col xs={24} md={8} key={index}>
                      <ControlCard control={control} />
                    </Col>
                  ))}
                </Row>
              </section>

              <section style={{ marginBottom: "24px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <Title level={2}>FedRAMP Rev 5 High</Title>
                  <Link
                    to="/fedramp-rev-5-high"
                    style={{
                      fontWeight: 400,
                      color: "#2270FF",
                      textDecoration: "none",
                    }}
                  >
                    See All ({totalFedrampRev5Controls})
                  </Link>
                </div>
                <Paragraph
                  style={{
                    color: "#666",
                    marginBottom: "24px",
                    fontSize: "16px",
                  }}
                >
                  Controls are the specific safeguards or security requirements
                  put in place to reduce risk and protect systems, data, and
                  operations.
                </Paragraph>

                <Row gutter={[24, 24]}>
                  {fedrampRev5Controls.map((control, index) => (
                    <Col xs={24} md={8} key={index}>
                      <ControlCard control={control} />
                    </Col>
                  ))}
                </Row>
              </section>
            </>
          )}
        </div>
      </Content>

      <CustomFooter />

      <RequestAccessModal
        visible={isModalVisible}
        onCancel={handleModalCancel}
      />
    </Layout>
  );
}
